import { render } from "./NuanceChat.vue?vue&type=template&id=41d1ec42&scoped=true"
import script from "./NuanceChat.vue?vue&type=script&lang=js"
export * from "./NuanceChat.vue?vue&type=script&lang=js"

import "./NuanceChat.vue?vue&type=style&index=0&id=41d1ec42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d1ec42"]])

export default __exports__